import { render } from "./MailFrom.vue?vue&type=template&id=3e1a2596"
import script from "./MailFrom.vue?vue&type=script&lang=js"
export * from "./MailFrom.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/Work/MANTEE_HOME/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__